const inboxUrl = (mail) => {
	const { id, contact_id } = mail;
	if (!contact_id) return id.toString();
	return `${id.toString()}/${contact_id.toString()}`;
};

export { inboxUrl };
